const BN_DIGITS = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

export function toBn(value: string | number): string {
  return String(value).replace(/[0-9]/g, (d) => BN_DIGITS[Number(d)]);
}

export function bnNum(n: number): string {
  return toBn(n.toLocaleString('en-IN'));
}

export function bnPercent(n: number): string {
  return `${toBn(n)}%`;
}

export function maskMobile(mobile: string): string {
  if (mobile.length < 11) return mobile;
  return `${mobile.slice(0, 5)}****${mobile.slice(-2)}`;
}

export function maskName(name: string): string {
  const parts = name.split(' ');
  return parts
    .map((p, i) => (i === 0 && p.endsWith('ঃ') ? p : i === parts.length - 1 ? p : `${p.slice(0, 2)}***`))
    .join(' ');
}
